import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../theme';
import { TravellerDisability } from '@websky/graphql';

interface Props {
	disabilities: TravellerDisability[];
}

const Disabilities: React.FC<Props> = ({ disabilities }) => {
	const { Disabilities: css } = useTheme('PassengersDetails');
	const { t } = useTranslation('OrderCard');

	return (
		<div className={css.root}>
			<div className={css.disabilities}>
				<div className={css.disabilities__header}>{t('Additional information')}</div>

				<div className={css.disabilities__list}>
					{disabilities.map(disability => (
						<React.Fragment key={disability.id}>
							<span>{disability.id}</span>
							<span>{'-'}</span>
							<span>{disability.name}</span>
						</React.Fragment>
					))}
				</div>
			</div>
		</div>
	);
};

export default Disabilities;
